export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-dollar-bill-747c51ad7654038893cb2ab7ce9903c5.svg";